var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/percent"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15533 4.15533C3.2398 5.07086 2.75 6.57397 2.75 9V15C2.75 17.426 3.2398 18.9291 4.15533 19.8447C5.07086 20.7602 6.57397 21.25 9 21.25H15C17.426 21.25 18.9291 20.7602 19.8447 19.8447C20.7602 18.9291 21.25 17.426 21.25 15V9C21.25 6.57397 20.7602 5.07086 19.8447 4.15533C18.9291 3.2398 17.426 2.75 15 2.75H9C6.57397 2.75 5.07086 3.2398 4.15533 4.15533ZM3.09467 3.09467C4.42914 1.7602 6.42603 1.25 9 1.25H15C17.574 1.25 19.5709 1.7602 20.9053 3.09467C22.2398 4.42914 22.75 6.42603 22.75 9V15C22.75 17.574 22.2398 19.5709 20.9053 20.9053C19.5709 22.2398 17.574 22.75 15 22.75H9C6.42603 22.75 4.42914 22.2398 3.09467 20.9053C1.7602 19.5709 1.25 17.574 1.25 15V9C1.25 6.42603 1.7602 4.42914 3.09467 3.09467Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6404 8.19968C15.9333 8.49257 15.9333 8.96745 15.6404 9.26034L9.1004 15.8003C8.80751 16.0932 8.33263 16.0932 8.03974 15.8003C7.74684 15.5074 7.74684 15.0326 8.03974 14.7397L14.5797 8.19968C14.8726 7.90679 15.3475 7.90679 15.6404 8.19968Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98001 8.66C8.71491 8.66 8.5 8.87492 8.5 9.14001C8.5 9.40509 8.71489 9.62 8.98001 9.62C9.24511 9.62 9.45999 9.40511 9.45999 9.14001C9.45999 8.87489 9.24508 8.66 8.98001 8.66ZM7 9.14001C7 8.04649 7.88649 7.16 8.98001 7.16C10.0736 7.16 10.96 8.04651 10.96 9.14001C10.96 10.2335 10.0735 11.12 8.98001 11.12C7.88651 11.12 7 10.2336 7 9.14001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.52 14.38C15.2549 14.38 15.04 14.5949 15.04 14.86C15.04 15.1251 15.2549 15.34 15.52 15.34C15.7851 15.34 16 15.1251 16 14.86C16 14.5949 15.7851 14.38 15.52 14.38ZM13.54 14.86C13.54 13.7665 14.4265 12.88 15.52 12.88C16.6135 12.88 17.5 13.7664 17.5 14.86C17.5 15.9535 16.6135 16.84 15.52 16.84C14.4265 16.84 13.54 15.9535 13.54 14.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.46e1314c9e38a252bbc4739ffca66aef.svg";
export { ForwardRef as ReactComponent };